<div class="modal-header">
  <h5 class="modal-title" id="myModalLabel">{{ title}}</h5>
  <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"
    (click)="onClose('cancel')"></button>
</div>
<div class="modal-body">
  <h5 class="font-size-16" [innerHTML]="message"></h5>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-secondary" data-bs-dismiss="modal" (click)="onClose('cancel')">
    Close
  </button>
  <button type="button" class="btn btn-primary" (click)="onClose('confirm')">
    Confirm
  </button>
</div>